import React, { useState, useEffect } from "react";
import {
	get_cookies,
	getBranchidno,
	timeZoneChanger,
	time,
} from "../../components/Cookies/Cookies";
import clsx from 'clsx';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import ph from '../../assets/Flags/ph.png';
import hk from '../../assets/Flags/HONGKONG.png';
import ity from '../../assets/Flags/ITALY.png';
import kr from '../../assets/Flags/KOREA.jpg';
import ksa from '../../assets/Flags/KSA.png';
import my from '../../assets/Flags/MALAYSIA.png';
import ng from '../../assets/Flags/NIGERIA.png';
import qtr from '../../assets/Flags/QATAR.png';
import sg from '../../assets/Flags/SG.png';
import twn from '../../assets/Flags/TAIWAN.png';
import uae from '../../assets/Flags/UAE.png';
import omn from '../../assets/Flags/OMAN.png';
import swtz from '../../assets/Flags/Switzerland.png';
import cnd from '../../assets/Flags/Canada.png';
import brn from '../../assets/Flags/Brunei.png';
import worldMap from '../../assets/img/bg_map.png';
import phMap from '../../assets/Flags/phlog.png';
import dubaiMap from '../../assets/Flags/dubailog.png';
import qatarMap from '../../assets/Flags/qatarlog.png';
import ksaMap from '../../assets/Flags/ksalog.png';
import koreaMap from '../../assets/Flags/korealog.png';
import taiwanMap from '../../assets/Flags/taiwanlog.png';
import abudhabiMap from '../../assets/Flags/abudhabilog.png';
import omanMap from '../../assets/Flags/omanlog.png';
import singaporeMap from '../../assets/Flags/singaporelog.png';
import hongkongMap from '../../assets/Flags/hongkonglog.png';
import nigeriaMap from '../../assets/Flags/nigerialog.png';
import italyMap from '../../assets/Flags/italylog.png';
import malaysiaMap from '../../assets/Flags/malaysialog.png';
import { Avatar, List, ListItem, ListItemText } from '@material-ui/core';

// material ui
import { DashboardTwoTone, Translate } from "@material-ui/icons";
import { setDate } from "date-fns";


const Dashboard = () => {
	let username = get_cookies("fullname");
	let branchidno = getBranchidno("branchidno");
	const moment = require('moment-timezone');
	const [branchIdNo, setBranchIdNo] = React.useState("");
	const [selectedDate, setSelectedDate] = React.useState("");
	const [selectedTime, setSelectedTime] = React.useState("");
	const [selectedFlag, setSelectedFlag] = React.useState("");
	const [selectedCountry, setSelectedCountry] = React.useState("");
	const [selectedWorldClock, setSelectedWorldClock] = React.useState(new Date());
	const [hideText, setHideText] = useState(false);
	const [Map, setMap] = React.useState(worldMap);
	const [translateSub, setTranslateSub] = React.useState("Welcome");
	const useStyles = makeStyles((theme) => ({
		root: {
			padding:"0",
			margin:"0",
			fontFamily: "Montserrat!important",
			backgroundColor: "#fff"
		},
		paper: {

			textAlign: 'left',
			color: theme.palette.text.secondary,
		},
		gridLeft: {
			height: "200px",
			backgroundColor: "#fff"
		},
		large: {
			width: theme.spacing(13),
			height: theme.spacing(13),
			boxShadow: theme.shadows[3],
		},
		userTab: {
			fontFamily: "Montserrat",
			color: "#525252"
		},
		flagTab: {
			display: 'flex',
			justifyContent: 'space-between',
			fontFamily: "Montserrat",
			color: "#525252",
			paddingBottom: "0px!important",
			paddingLeft: "1rem",
			paddingRight: "1rem",

		},
		listItemFormat: {
			display: 'flex',
			justifyContent: 'space-between',
			fontFamily: "Montserrat",
			color: "#525252",
			paddingTop: "0px!important",
			paddingBottom: "0px!important"
		},
		listItemText: {
			fontSize: "10px",
			fontWeight: "700",

		},
		whiteBackground: {
			backgroundColor: "#fff",
		},
		textSubtitle: {
			marginBottom: "0px!important",
		},
	}));
	const classes = useStyles();

	//   const date = moment.tz(new Date(), "Asia/Manila");
	// //   const showTime =date.getHours() 
	//     + ':' + date.getMinutes() 
	//     + ":" + date.getSeconds();

	useEffect(() => {
		timeZoneChanger(setSelectedDate);
		setInterval(() => time(setSelectedTime), 1000);
		setInterval(() => setSelectedWorldClock(new Date()), 1000);
		switch (branchidno) {
			case "DAVAOHQ":
				setSelectedFlag(ph);
				setBranchIdNo("HQ DAVAO");
				setSelectedCountry("Philippines");
				setHideText("Philippines");
				setMap(phMap);
				setTranslateSub("Welcome");
				break;
			case "DUBAIHQ":
				setSelectedFlag(uae);
				setBranchIdNo("HQ DUBAI");
				setSelectedCountry("Dubai");
				setHideText("Dubai");
				setMap(dubaiMap);
				setTranslateSub("Ahlan bik");
				break;
			case "NIGERIAHQ":
				setSelectedFlag(ng);
				setBranchIdNo("HQ NIGERIA");
				setSelectedCountry("Nigeria");
				setHideText("Nigeria");
				setMap(nigeriaMap);
				setTranslateSub("Kaabo");
				break;
			case "TAIWANHQ":
				setSelectedFlag(twn);
				setBranchIdNo("HQ TAIWAN");
				setSelectedCountry("Taiwan");
				setHideText("Taiwan");
				setMap(taiwanMap);
				setTranslateSub("Huānyíng");
				break;
			case "CEBUHQ":
				setSelectedFlag(ph);
				setBranchIdNo("HQ CEBU");
				setSelectedCountry("Philippines")
				setHideText("Philippines");
				setMap(phMap);
				setTranslateSub("Welcome");
				break;
			case "QATARHQ":
				setSelectedFlag(qtr);
				setBranchIdNo("HQ QATAR");
				setSelectedCountry("Qatar")
				setHideText("Qatar");
				setMap(qatarMap);
				setTranslateSub("Ahlan bik");
				break;
			case "SINGAPOREHQ":
				setSelectedFlag(sg);
				setBranchIdNo("HQ SINGAPORE");
				setSelectedCountry("Singapore")
				setHideText("Singapore");
				setMap(singaporeMap);
				setTranslateSub("Welcome");
				break;
			case "KOREAHQ":
				setSelectedFlag(kr);
				setBranchIdNo("HQ KOREA");
				setSelectedCountry("Korea")
				setHideText("Korea");
				setMap(koreaMap);
				setTranslateSub("hwan-yeonghada");
				break;
			case "OMANHQ":
				setSelectedFlag(omn);
				setBranchIdNo("HQ OMAN");
				setSelectedCountry("Oman")
				setHideText("Oman");
				setMap(omanMap);
				setTranslateSub("Ahlan bik");
				break;
			case "ITALYHQ":
				setSelectedFlag(ity);
				setBranchIdNo("HQ ITALY");
				setSelectedCountry("Italy")
				setHideText("Italy");
				setMap(italyMap);
				setTranslateSub("Benvenuto");
				break;
			case "ABUDHABIHQ":
				setSelectedFlag(uae);
				setBranchIdNo("HQ ABUDDHABI");
				setSelectedCountry("Abudhabi")
				setHideText("Abudhabi");
				setMap(abudhabiMap);
				setTranslateSub("Ahlan bik");
				break;
			case "KSAHQ":
				setSelectedFlag(ksa);
				setBranchIdNo("HQ KSA");
				setSelectedCountry("Kingdom of Saudi Arabia")
				setHideText("ksa");
				setMap(ksaMap);
				setTranslateSub("Ahlan bik");
				break;
			case "HONGKONGHQ":
				setSelectedFlag(hk);
				setBranchIdNo("HQ HONGKONG");
				setSelectedCountry("Hongkong")
				setHideText("Hongkong");
				setMap(hongkongMap);
				setTranslateSub("Huānyíng");
				break;
			case "MALAYSIAHQ":
				setSelectedFlag(my);
				setBranchIdNo("HQ MALAYSIA");
				setSelectedCountry("Malaysia")
				setHideText("Malaysia");
				setMap(malaysiaMap);
				setTranslateSub("Selamat datang");
				break;

			case "CANADAHQ":
				setSelectedFlag(cnd);
				setBranchIdNo("HQ Canda");
				setSelectedCountry("Canada")
				setHideText("Canada");
				setMap(malaysiaMap);
				setTranslateSub("Welcome");
				break;

			case "SWITZERLANDHQ":
				setSelectedFlag(swtz);
				setBranchIdNo("HQ Switzerland");
				setSelectedCountry("Switzerland")
				setHideText("Switzerland");
				setMap(malaysiaMap);
				setTranslateSub("Willkommen");
				break;

			case "BRUNEIHQ":
				setSelectedFlag(brn);
				setBranchIdNo("HQ Brunei");
				setSelectedCountry("Brunei")
				setHideText("Brunei");
				setMap(malaysiaMap);
				setTranslateSub("Good Day");
				break;
			case "JAPANHQ":
				setSelectedFlag("");
				setBranchIdNo("HQ Japan");
				setSelectedCountry("Japan")
				setHideText("Japan");
				setMap(malaysiaMap);
				setTranslateSub("Yoi tsuitachi");
				break;
				case "SPAINHQ":
					setSelectedFlag("");
					setBranchIdNo("HQ Spain");
					setSelectedCountry("Spain")
					setHideText("Spain");
					setMap(malaysiaMap);
					setTranslateSub("Bienvenido");
					break;
					case "USAHQ":
						setSelectedFlag("");
						setBranchIdNo("HQ Usa");
						setSelectedCountry("Usa")
						setHideText("Usa");
						setMap(malaysiaMap);
						setTranslateSub("Good Day");
						break;
						case "AUSTRALIAHQ":
							setSelectedFlag("");
							setBranchIdNo("HQ Australia");
							setSelectedCountry("Australia")
							setHideText("Australia");
							setMap(malaysiaMap);
							setTranslateSub("Good Day");
							break;
						case "UGANDAHQ":
							setSelectedFlag("");
							setBranchIdNo("HQ Uganda");
							setSelectedCountry("Uganda")
							setHideText("Uganda");
							setMap(malaysiaMap);
							setTranslateSub("Good Day");
							break;
	
			default:
				setSelectedFlag(ph);
				setBranchIdNo("HQ DAVAO");
				setSelectedCountry("Philippines")
				setHideText("Philippines");
				setTranslateSub("Welcome");
				setMap(phMap);
				break;
		}

	}, []);

	return (

		<Grid container className={classes.root} >
			<Grid container justifyContent="center" spacing={4}>
				<Grid item xs={12} sm={6} className={classes.gridLeft} style={{ backgroundImage: `url(${Map})`, backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }} >

					<div className={classes.userTab}  >
						<h1 >{translateSub}, {username}</h1>
						<h4 className={classes.textSubtitle}>Here's to the good life</h4>
					</div>

				</Grid>
				<Grid item xs={12} sm={6} className={classes.whiteBackground} >

					<div className={classes.flagTab} style={{ marginBottom: "0px!important" }}>
						<div>
							<h1 className={classes.textSubtitle}>{selectedCountry}</h1>
							<h4 className={classes.textSubtitle}>{selectedDate}</h4>
							<h1 className={classes.textSubtitle}>{selectedTime}</h1>
						</div>
						{selectedFlag == "" ? null :<Avatar src={selectedFlag} className={classes.large} style={{ marginRight: "5rem" }}></Avatar>}

					</div>
				</Grid>

			</Grid>
							<Grid item xs={12} sm={12} className={classes.whiteBackground} >

					<h3 style={{ paddingLeft: "1rem" }}>World Clock</h3>

					<Grid container spacing={2}  >
						<Grid item xs={12} sm={6}>
							<List disablePadding="true">

								{hideText != "Philippines" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Philippines" primary="Today +8 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Asia/Manila").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}

								{hideText != "Dubai" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Dubai" primary="Today +4 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Asia/Dubai").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "Taiwan" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Taiwan" primary="Today +8 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Asia/Taipei").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "Oman" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Oman" primary="Today +4 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Asia/Muscat").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "Italy" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Italy" primary="Today +1 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Europe/Rome").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "Abudhabi" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Abudhabi" primary="Today +4 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Asia/Dubai").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "Canada" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Canada" primary="Today +4 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Canada/Pacific").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "Switzerland" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Switzerland" primary="Today +2 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Europe/Zurich").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "Spain" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									{/* <ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Spain" primary="Today +1 GMT" /> */}
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Spain" primary="Today +1 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Europe/Rome").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "Japan" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Japan" primary="Today +1 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Asia/Tokyo").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}

							</List>
						</Grid>
						<Grid item xs={12} sm={6}>
							<List>

								{hideText != "Qatar" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Qatar" primary="Today +3 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Asia/Qatar").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "Singapore" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Singapore" primary="Today +8 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Asia/Singapore").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "Korea" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Korea" primary="Today +9 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Asia/Seoul").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "Hongkong" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Hongkong" primary="Today +8 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Asia/Hong_Kong").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "Malaysia" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700", width: "90px" } }} secondary="Malaysia" primary="Today +8 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Asia/Kuala_Lumpur").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "ksa" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									    <ListItemText
										primary="Today +3 GMT"
										secondary="Kingdom of Saudi Arabia"
										primaryTypographyProps={{ style: { fontSize: "10px" } }}
										secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700" } }}
										/>
									    <ListItemText
										primary={moment.tz(selectedWorldClock, "Asia/Riyadh").format("h:mm:ss A")}
										primaryTypographyProps={{ style: { fontWeight: "700", textAlign: "right" } }}
										style={{ flex: "0 0 auto" }} // prevent stretching
										/>
								</ListItem></>) : ""}
								{hideText != "Brunei" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700" } }} secondary="Brunei" primary="Today +8 UTC" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Asia/Brunei").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
								</ListItem></>) : ""}
								{hideText != "United States" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700" } }} secondary="United States" primary="Today +8 UTC" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Us/Central").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
									
								</ListItem></>) : ""}
								{hideText != "Qatar" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700" } }} secondary="Qatar" primary="Today +3 GMT" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Asia/Qatar").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
									
								</ListItem></>) : ""}
								{hideText != "Uganda" ? (<> <ListItem className={classes.listItemFormat} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<ListItemText primaryTypographyProps={{ style: { fontSize: "10px" } }} secondaryTypographyProps={{ style: { fontSize: "14px", fontWeight: "700" } }} secondary="Uganda" primary="Today +3 UTC" />
									<ListItemText primaryTypographyProps={{ style: { fontWeight: "700" } }} primary={moment.tz(selectedWorldClock, "Africa/Kampala").format('h:mm:ss A ')}style={{ flex: "0 0 auto" }} ></ListItemText>
									
								</ListItem></>) : ""}
							</List>
						</Grid>
					</Grid>
				</Grid>
		</Grid>

	);
};

export default Dashboard;
